import { useEffect, useMemo } from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
import OrganoOrigen from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/OrganoOrigen/OrganoOrigen'
import OrigenCautelar from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/OrigenCautelar/OrigenCautelar'
// import Resolucion from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/Resolucion/Resolucion'
import TipoOrigenToggleBtn from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/components/TipoOrigen/TipoOrigen'
import { TIPO_ORIGEN } from 'src/components/views/EscritosLexnet/components/IniciadorAsunto/components/Origen/consts'
import NIG from 'src/components/views/EscritosLexnet/components/shared/components/NIG/NIG'
import Procedimiento from 'src/components/views/EscritosLexnet/components/shared/components/Procedimiento/Procedimiento'
import { EscritosFormValues } from 'src/components/views/EscritosLexnet/components/shared/types/escritosFormTypes'
import { FormField } from 'src/enums/Form'
import { useEscritosFormContext } from '../../../shared/components/SubmitForm'

function Origen(): JSX.Element {
  const { t } = useTranslation()
  const { values, setFieldValue, validateForm } = useFormikContext<EscritosFormValues>()
  const organoOrigenTipoOrigen = values[FormField.ORGANO_ORIGEN_TIPO_ORIGEN]
  const showTipoOrigenToggleBtn =
    values[FormField.ORGANO_DESTINO]?.organoDestinoOrganoJudicial?.tribunalSupremo
  const { validateAfterSubmit } = useEscritosFormContext()

  useEffect(() => {
    setFieldValue(FormField.ORGANO_ORIGEN_COMUNIDAD_AUTONOMA, null, false)
    setFieldValue(FormField.ORGANO_ORIGEN_PROVINCIA, null, false)
    setFieldValue(FormField.ORGANO_ORIGEN_PARTIDO_JUDICIAL, null, false)
    setFieldValue(FormField.ORGANO_ORIGEN_ORGANO_JUDICIAL, null, false)
    setFieldValue(FormField.ORGANO_ORIGEN, null, false)
    setFieldValue(FormField.ORGANO_ORIGEN_DESCRIPCION, '', false)
    setFieldValue(FormField.ORGANO_ORIGEN_ORDEN_DESCRIPCION, '', false)
    setFieldValue(FormField.ORGANO_ORIGEN_ORGANISMO_ORIGEN, null, false)
    setFieldValue(FormField.ORGANO_ORIGEN_NUMERO_EXPEDIENTE, '', false)
    setFieldValue(FormField.ORGANO_ORIGEN_YEAR_EXPEDIENTE, '', false)
    setFieldValue(FormField.ORGANO_ORIGEN_COMUNIDAD_AUTONOMA, null, false)
  }, [organoOrigenTipoOrigen, setFieldValue])

  const renderTipoOrigenToggleBtn = useMemo((): JSX.Element => {
    if (showTipoOrigenToggleBtn) {
      return <TipoOrigenToggleBtn />
    }
    return <OrigenCautelar />
  }, [showTipoOrigenToggleBtn])

  useEffect(() => {
    if (showTipoOrigenToggleBtn) {
      setFieldValue(FormField.ORGANO_ORIGEN_TIPO_ORIGEN, TIPO_ORIGEN.JUDICIAL, false)
    } else {
      setFieldValue(FormField.ORGANO_ORIGEN_TIPO_ORIGEN, null, false)
    }
  }, [showTipoOrigenToggleBtn, setFieldValue])

  useEffect(() => {
    if (validateAfterSubmit) {
      validateForm()
    }
  }, [values[FormField.CAUTELAR]])

  return (
    <FieldsetGroup legend={t('form.legend.origen')}>
      {renderTipoOrigenToggleBtn}
      <OrganoOrigen />
      {organoOrigenTipoOrigen !== TIPO_ORIGEN.EXTRAJUDICIAL && <Procedimiento />}
      <NIG />
      {/* <Resolucion /> */}
    </FieldsetGroup>
  )
}

export default Origen
